import { EnvironmentType } from '@rccl/telemetry-events';
import { CHECKIN_SHIPS, CHECKOUT_SHIPS } from '~app/shared/constants/ships.constant';
import { Feature } from '~app/shared/enums/feature.enum';
import { Role } from '~app/shared/enums/role.enum';

// tslint:disable:max-line-length
export const BASE_ENV = {
  production: true,
  hmr: false,
  version: '2.3.0',
  pdfViewerSupported: {
    desktop: {
      chrome: '>40',
      firefox: '>51',
      opera: '>51',
      safari: '>10',
      'Microsoft Edge': '>15',
    },
  },
  consoleViewUnsupported: {
    desktop: {
      safari: '>1',
    },
    tablet: {
      safari: '>1',
    },
    mobile: {
      safari: '>1',
    },
  },
  auth: {
    authPage: 'https://myrclhome.com/main_login',
    managerGroup: [
      Role.HRManager,
      Role.HRTeam,
      Role.Admin,
      Role.Medical,
      Role.Safety,
      Role.Finance,
      Role.CrewAdminManager,
    ],
    adminGroup: Role.Admin,
  },
  mw: {
    host: 'https://aws-prd.api.rccl.com',
    locale: 'en',
    brand: 'royal',
    channel: 'web',
    shortCacheTime: 5000,
    longCacheTime: 120000,
    appKey: 'wII2XHCmdA5yM91ft5a2axF7wkgplh8u',
  },
  analytics: {
    scriptSrc:
      'https://assets.adobedtm.com/6511a4b4a5ced57d6adb5e89b5a3e0559f22a299/satelliteLib-46ea689a9f196472c93b9b56069d9075467a98bf.js',
  },
  featureFlags: {
    [Feature.Analytics]: true,
    [Feature.CheckIn]: CHECKIN_SHIPS,
    [Feature.CheckOut]: CHECKOUT_SHIPS,
    [Feature.eSignature]: CHECKIN_SHIPS,
    [Feature.OnBoardDocuments]: [''],
    [Feature.Medical]: [
      'HM',
      'AD',
      'EG',
      'AN',
      'MA',
      'NV',
      'AX',
      'AL',
      'AT',
      'CS',
      'FR',
      'IC',
      'IN',
      'OV',
      'QN',
      'SC',
      'SL',
      'SY',
      'EQ',
      'EN',
      'ID',
      'OA',
      'RF',
      'RH',
      'SI',
      'SM',
      'SR',
      'ST',
      'VI',
      'EC',
      'LB',
      'ML',
      'VY',
      'EX',
      'JW',
      'RD',
      'BR',
      'BY',
      'GR',
      'OY',
      'WN',
      'UT',
      'XC',
      'LE',
    ],
    [Feature.Safety]: [''],
    [Feature.RateModal]: true,
    [Feature.CrewPhoto]: true,
    [Feature.CrewPhotoUpdate]: [
      'AD',
      'AN',
      'AT',
      'EG',
      'HM',
      'NV',
      'MA',
      'AX',
      'AL',
      'CS',
      'FR',
      'IC',
      'IN',
      'OV',
      'QN',
      'SC',
      'SY',
      'EQ',
      'EN',
      'ID',
      'OA',
      'RF',
      'RH',
      'SI',
      'SM',
      'SR',
      'ST',
      'VI',
      'ML',
      'VY',
      'OY',
      'WN',
      'SL',
      'LB',
      'EC',
      'BR',
      'BY',
      'GR',
      'JW',
      'EX',
      'RD',
      'UT',
      'XC',
      'LE',
    ],
    [Feature.DocManagerFinance]: true,
    [Feature.AdminSummary]: true,
    [Feature.DocManagerIdSearch]: true,
    [Feature.CrewCheckinInfoReport]: [''],
    [Feature.PolicyAcknowledgementReport]: CHECKIN_SHIPS,
    [Feature.LateSignOnReport]: [''],
    [Feature.HealthCheckReport]: [''],
    [Feature.MissingSharepointSignonsReport]: [''],
    [Feature.MedicalCertificates]: [
      'HM',
      'AD',
      'AT',
      'EG',
      'AN',
      'MA',
      'NV',
      'AX',
      'AL',
      'CS',
      'FR',
      'IC',
      'IN',
      'OV',
      'QN',
      'SC',
      'SL',
      'SY',
      'EQ',
      'EN',
      'ID',
      'OA',
      'RF',
      'RH',
      'SI',
      'SM',
      'SR',
      'ST',
      'VI',
      'EC',
      'LB',
      'ML',
      'VY',
      'EX',
      'JW',
      'RD',
      'BR',
      'BY',
      'GR',
      'OY',
      'WN',
      'UT',
      'XC',
      'LE',
    ],
    [Feature.CovidVaxReport]: true,
    [Feature.LastOnboard]: true,
  },
  telemetry: {
    appId: 'Web.PreCheck',
    batch: {
      batchSize: 10,
      isEnabled: true,
    },
    debug: false,
    enabled: true,
    env: EnvironmentType.CLOUD_PROD,
    trackingUrl: 'https://aws-prd.api.rccl.com/en/royal/web/v1/ee/telemetry/events',
  },
  homeport: {
    host: 'https://homeport.rccl.com',
    token: '014f317ef6a9e6a1d663fb372d44a4feb17ebf44cff057754c38d6cc995f38a4',
    categories: {
      news: [1024],
      leadership: [1027],
      rci: [1054],
      cel: [1053],
      azm: [1052],
      rciCorp: [1024, 1054],
      celCorp: [1024, 1053],
      azmCorp: [1024, 1052],
    },
  },
};
